export default(state,action) => {
    switch (action.type) {
        case "SET_LOADING":
            return { ...state, loading: action.payload };
        case "SET_ERROR":
            return { ...state, error: action.payload };
        case "LOGIN":
            return { ...state, user: action.payload, error: null };
        case "LOGOUT":
            return { ...state, user: null, error: null };
        default:
            return state;
    }   
}